/**
 * Short customer-facing receipt number — hides internal VENTE-YYYY-NNNNNN format.
 * Shows the sequence number only (no VENTE prefix, no year).
 * Example: VENTE-2026-000123 → 123
 */
export function formatCustomerReceiptNumber(orderId) {
  if (orderId == null || orderId === '') return '';

  const str = String(orderId).trim();
  const isoMatch = str.match(
    /(?:^|[A-Za-z0-9_-]+-)?(?:VENTE|SALE|SAL|QUITT|FACT|CMD)-\d{4}-(\d+)$/i
  );

  if (isoMatch) {
    const seq = parseInt(isoMatch[1], 10);
    return Number.isFinite(seq) ? String(seq) : isoMatch[1].replace(/^0+/, '') || '0';
  }

  const trailing = str.match(/(\d+)$/);
  if (trailing) {
    const seq = parseInt(trailing[1], 10);
    return Number.isFinite(seq) ? String(seq) : trailing[1];
  }

  return str;
}
